<template>
    <div class="inner-box" style="margin-left: -100px;">
        <el-form>
            <div class="table-header">
                <div class="table-name" style="width: 70%;">
                    <h3><i class="el-icon-headset"></i> 
                        <i> {{ `설문참여` }}</i></h3>
                </div>
                <el-button style="width: 30%; align-items: center; margin-top: 30px; font-size: 2.5em; flex-direction: column; bottom: 0; float:right;" size="medium" round type="primary" icon="el-icon-check" @click="saveCustreply">
                    저장
                </el-button>
                <!-- <div class="btn-wrap btn-type1 clearfix" style="width: 30%; flex-direction: column; display: flex;">
                    
                    <button class="btn-size btn-gray fl_left" @click="saveCustreply" v-if="showSave">
                    <span class="btn-icon">
                        <i class="fas fa-save"></i>
                    </span>
                    저장
                </button>
                </div> -->
            </div>
            <el-divider class="h3-divider"></el-divider>
            <el-form label-width="120px" size="mini">
        
                <div class="el-tab-pane survey">
                    <el-row v-for="(item, idx) in campaignSurveyList" :key="idx" >
                        <el-descriptions :column="1" direction="vertical" border>
                            <el-descriptions-item :label="'질문 '+item.questionSeq+'.'">
                                <el-row>
                                    <el-col prop="reply1Desc" >
                                        {{ item.questionDesc }}<br/>
                                    </el-col>
                                </el-row>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-divider></el-divider>
                        <el-row>
                            <el-col>
                                <el-radio-group v-model="item.selReply" size="mini">
                                    <el-radio :label="1" v-if="item.reply1Desc">{{ item.reply1Desc }}</el-radio>
                                    <el-divider v-if="item.reply1Desc"></el-divider>
                                    <el-radio :label="2" v-if="item.reply2Desc">{{ item.reply2Desc }}</el-radio>
                                    <el-divider v-if="item.reply2Desc"></el-divider>
                                    <el-radio :label="3" v-if="item.reply3Desc">{{ item.reply3Desc }}</el-radio>
                                    <el-divider v-if="item.reply3Desc"></el-divider>
                                    <el-radio :label="4" v-if="item.reply4Desc">{{ item.reply4Desc }}</el-radio>
                                    <el-divider v-if="item.reply4Desc"></el-divider>
                                    <el-radio :label="5" v-if="item.reply5Desc">{{ item.reply5Desc }}</el-radio>
                                    <el-divider v-if="item.reply5Desc"></el-divider>
                                    <el-radio :label="6" v-if="item.reply6Desc">{{ item.reply6Desc }}</el-radio>
                                    <el-divider v-if="item.reply6Desc"></el-divider>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                    </el-row>
                </div> 
            </el-form>
            <br>
            <el-form label-width="120px" size="mini">
                <el-row :gutter="24">
                    <el-col>
                        <div class="sub-title">
                            <div class="table-name">
                                <h3>
                                    <i class="el-icon-chat-line-round"></i> 
                                    {{ `설문비고` }}</h3>
                            </div>
                        </div>
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="설문비고를 작성해 주세요."
                        v-model="form.custComment">
                        </el-input>
                    </el-col>
                </el-row>
            </el-form>
            <br>
            <div class="table-header">
                <div class="btn-wrap btn-type1 clearfix">
                    <button class="btn-size btn-gray fl_left" @click="saveCustreply" v-if="showSave">
                    <span class="btn-icon">
                        <i class="fas fa-save"></i>
                    </span>
                    저장
                    </button>
                    
                </div>
            </div>
        </el-form>
    </div>
</template>


<script>
/**
* * mixins
*/
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
* * components
*/
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';


 

export default {
  mixins: [slip, common],
  components: {AgGridVue, DhxCalendar},
  props: ['custParam'],
  data() {
      return {
        showSave: false,
        form: { custComment: '' },
        campaignSurveyList: [{
            questionDesc: '',
            questionSeq: 0,
            reply1Desc: '',
            reply2Desc: '',
            reply3Desc: '',
            reply4Desc: '',
            reply5Desc: '',
            reply6Desc: '',
            custComment: '',
            selReply: 0
          }],
          data: [],
          radio: 1,
      }
  },
  computed: {
      
  },
  created() {
      
  },
  mounted() {
      this.selectQuestItem('INIT');
  },
  methods: {
       
      selectQuestItem(param){
          /** 설문문항 조회 */
          
          let vApplyYn = 'N';
          this.showSave = false;
          
          const vform = {
              companyId: 'CENTERLINK',
              campaignId: this.$route.query.campaignId,
              campaignCustId: this.$route.query.custId
          }
          this.$store.commit('loading')
          console.log('selectQuestItem : ', vform) 
          this.$http.post(("/api/pop/happyCallSurvey/selectQuestItem"), vform
              ).then(response => {
              
              if(response.data){
                if (param === 'INIT'){
                    this.campaignSurveyList = _.cloneDeep(response.data);
                }
                
                const vApplyCnt = response.data[0]?.applyCnt;
                if(vApplyCnt > 0){
                  if (param === 'INIT' || param === 'VALID'){
                    this.$swal({ type: 'warning', text: '이미 설문에 참여하였습니다.' });
                  }  

                  vApplyYn = 'Y';
                } else {
                    this.showSave = true;
                }
              } else {
                this.$swal({ type: 'warning', text: '해당 설문이 존재하지 않습니다.' });
              }
              
          }).finally(() => {
              this.$store.commit('finish')
          });

          return vApplyYn;
      },
      saveCustreply(){
        const vRet = this.selectQuestItem('VALID');
        if(vRet === 'Y'){
            return false;
        }

        console.log('this.campaignSurveyList: ', this.campaignSurveyList);
        const vNoCheckList = this.campaignSurveyList.filter(x=>!x.selReply || x.selReply==0);
        if(vNoCheckList.length > 0)
        {
            this.$swal({ type: 'warning', text: '질문항목을 체크해 주세요.' });

            return false;
        }

        if(this.form.custComment === ''){
            this.$swal({ type: 'warning', text: '설문비고를 작성해 주세요.' });

            return false;
        }
        
        this.$swal({
            type: 'warning',
            text: `저장하시겠습니까?`,
            showCancelButton: true,
            confirmButtonText: '예',
            cancelButtonText: '아니오',
        }).then((result) => {
            if (result.value) { 

                let vReply = _.cloneDeep(this.campaignSurveyList);
                console.log('saveAll start', vReply);
                vReply = vReply.map((x, index)=>{
                    
                    // x['selReply'] = 6-index;
                    x.campaignCustId = this.$route.query.custId;
                    x.companyId = 'CENTERLINK';
                    
                    if(index === 0){
                        x.custComment = this.form.custComment;
                    }

                    return x;
                });

                console.log('saveAll start2', vReply);
  
                this.$store.commit('loading');
                
                this.$http.put(("/api/pop/happyCallSurvey/saveCustreply"), vReply
                    ).then(response => {
                    console.log('saveAll response.data' , response.data);
                    this.$swal({ type: 'success', text: '설문에 참여해주셔서 감사합니다.' });
                    this.selectQuestItem('SAVE_RELOAD');
                }).finally(() => {
                    this.$store.commit('finish');
    
                });
            }
        });
      }
  }
}
</script>


<style scoped>
/* :global(.contents) {
    left: 0px !important;
    position: none !important;
    margin: 74px 30px auto 30px !important;
} */
/* .content {
    left: 0px !important;
    position: fixed !important;
    padding: 74px 30px auto 30px !important;
} */

h3 {
    font-size: 4.0em;
    /* background-color: #0065b3 !important;
    color: #fff !important; */
}

.h3-divider {
    background-color: #0065b3 !important;
    height: 0.4em;
}
.el-textarea {
    font-size: 1.8em;
}

textarea::placeholder {
    font-size: 2.0em;
}

/* :global(textarea::placeholder) {
    font-size: 2.0em;
} */

table tr th {
    font-size: 3.0em;
    background-color: #0065b3 !important;
    color: #fff !important;
}

/* :global(table tr th) {
    font-size: 3.0em;
    background-color: #0065b3 !important;
    color: #fff !important;
} */
table tr td {
    font-size: 2.5em;
}
/* :global(table tr td) {
    font-size: 2.5em;
} */
.el-radio__inner {
    width: 2.5em;
    height: 2.5em;
}
/* :global(.el-radio__inner) {
    width: 2.5em;
    height: 2.5em;
} */
.el-radio__label {
    font-size: 2.5em;
}
/* :global(.el-radio__label) {
    font-size: 2.5em;
} */
.el-form {
  border: 2px solid #0065b3;
  padding: 10px;
  border-radius: 5px;
}
</style>